import React, { Fragment } from 'react'
import { Helmet } from 'react-helmet'

import { AboutPage } from './components/'

const About = () => (
  <Fragment>
    <Helmet>
      <title> About - afrodesiamedia </title>
      <link rel="shortcut icon" href="/favicon.ico" />
      <meta property="og:type" content="company" />
      <meta property="og:url" content="https://www.afrodesiamedia.com/about" />
      <meta property="og:title" content="About" />
    </Helmet>
    <AboutPage />
  </Fragment>
)

export default About



// WEBPACK FOOTER //
// /Users/kentorry/Server/CLIENT-SERVER/CLIENT-WORK/afrodesiamedia/SERVER/afrodesiamedia/src/pages/About/About.js